<div class="content row">
    <div class="content-logo col-12 col-sm-4">
      <a href="#" (click)="navigateHome()">
        <img [src]="companyLogo" class="logo" [alt]="companyName">
      </a>
    </div>
    <div class="main-title col-12 col-sm-8" >
        <ng-container *ngIf="header$ | async as header">
            <ng-container *ngIf="isMobileView; else desktopTemplate">
                <h5>{{ header.title }}</h5>
                <spam *ngIf="header.subtitle" class="subtitle">{{ header.subtitle }}</spam>
            </ng-container>

            <ng-template #desktopTemplate>
                <h3>{{ header.title }}</h3>
                <h5 *ngIf="header.subtitle">{{ header.subtitle }}</h5>
            </ng-template>
        </ng-container>
    </div>
</div>
